import compose from '../../../../src/web/utils/react/compose';
import pure from '../../../../src/web/utils/react/pure';
import widget from '../../../../src/web/components/widgets/decorators/widget';
import editor from '../../../../src/web/components/widgets/decorators/editor';
import Button from './Button';
import Editor from './Editor';
import { NAME, ID } from './properties';

export default compose(
  editor(Editor),
  pure(),
  widget({ name: NAME, category: 'Buttons / Icons', componentId: ID }),
)(Button);
